if (document.querySelector('.maxburst-slider')) {
  
    let splide_length = document.querySelectorAll(".maxburst-slider .splide__slide").length;

  	if (splide_length === 1) {
        let maxburst_slider = new Splide(".maxburst-slider", {
            perPage: 1,
            rewind: false,
            drag: false,
            arrows: false,
            pagination: false,
        }).mount();
    } else if (splide_length === 2) {
        let maxburst_slider = new Splide(".maxburst-slider", {
            type: "loop",
            perPage: 2,
            perMove: 1,
            rewind: false,
            drag: false,
            arrows: false,
            pagination: false,
            gap: 15,
            breakpoints: {
                550: {
                    perPage: 1,
                    rewind: true,
                    drag: true,
                    arrows: true,
                    pagination: true,
                },
            },
        }).mount();
    } else if (splide_length === 3) {
        let maxburst_slider = new Splide(".maxburst-slider", {
            type: "loop",
            perPage: 3,
            perMove: 1,
            rewind: false,
            drag: false,
            arrows: false,
            pagination: false,
            gap: 15,
            breakpoints: {
                767: {
                    perPage: 2,
                    rewind: true,
                    drag: true,
                    arrows: true,
                    pagination: true,
                },
                550: {
                    perPage: 1,
                    rewind: true,
                    drag: true,
                    arrows: true,
                    pagination: true,
                },
            },
        }).mount();
    } else if (splide_length === 4) {
        let maxburst_slider = new Splide(".maxburst-slider", {
            type: "loop",
            perPage: 4,
            perMove: 1,
            rewind: false,
            drag: false,
            arrows: false,
            pagination: false,
            gap: 15,
            breakpoints: {
                1200: {
                    perPage: 3,
                    rewind: true,
                    drag: true,
                    arrows: true,
                    pagination: true,
                },
                767: {
                    perPage: 2,
                    rewind: true,
                    drag: true,
                    arrows: true,
                    pagination: true,
                },
                550: {
                    perPage: 1,
                    rewind: true,
                    drag: true,
                    arrows: true,
                    pagination: true,
                },
            },
        }).mount();
    } else if (splide_length >= 5) {
        let maxburst_slider = new Splide(".maxburst-slider", {
            type: "loop",
            perPage: 5,
            perMove: 1,
            rewind: true,
            drag: true,
            arrows: true,
            pagination: true,
            gap: 15,
            breakpoints: {
                1200: {
                    perPage: 3,
                },
                767: {
                    perPage: 2,
                },
                550: {
                    perPage: 1,
                },
            },
        }).mount();
    } else {
        let maxburst_slider = new Splide(".maxburst-slider").mount();
    } 
  
  	
  
  	/*let gallery_image = document.querySelectorAll(".maxburst-slider a.content-wrapper");
    let background = document.querySelector(".main_background");
    let background_image_box = document.querySelector(".background_image_box");
    let tag_img_image_box = document.querySelector(".background_image_box img");
  
  	gallery_image.forEach((gallery_image_current) => {
        gallery_image_current.addEventListener("click", (event) => {
            event.preventDefault();
            function show_bg() {
                return new Promise(function (resolve) {
                    tag_img_image_box.setAttribute("src", gallery_image_current.querySelector("img").getAttribute("src"));
                    background.classList.add("show_image_box_img");
                    resolve();
                });
            }
            function show_animate_bg() {
                return new Promise(function (resolve) {
                    setTimeout(function () {
                        background.classList.add("show_image_box_img_op");
                        resolve();
                    }, 200);
                });
            }
            function show_full_gallery(show_gallery_step) {
                return show_gallery_step.reduce(function (show_full_gallery_return, show_gallery_step) {
                    return show_full_gallery_return.then(show_gallery_step);
                }, Promise.resolve());
            }
            show_full_gallery([show_bg, show_animate_bg]).then();
        });
    });
  
  	background.addEventListener("click", (event) => {
        if (!background_image_box.contains(event.target)) {
            function hide_bg() {
                return new Promise(function (resolve) {
                    background.classList.remove("show_image_box_img_op");
                    resolve();
                });
            }
            function hide_animate_bg() {
                return new Promise(function (resolve) {
                    setTimeout(function () {
                        tag_img_image_box.setAttribute("src", "");
                        background.classList.remove("show_image_box_img");
                        resolve();
                    }, 500);
                });
            }
            function hide_full_gallery(hide_gallery_step) {
                return hide_gallery_step.reduce(function (hide_full_gallery_return, hide_gallery_step) {
                    return hide_full_gallery_return.then(hide_gallery_step);
                }, Promise.resolve());
            }
            hide_full_gallery([hide_bg, hide_animate_bg]).then();
        }
    });*/
}

!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {
	$('.content-wrapper').each(function() {
   		$(this).attr('href', $(this).find('img').attr('src'));
    });
    $('section').each(function () {
      if ($(this).is(':empty'))
        $(this).addClass('.hidden');      
      });
    
    if ($("#option-select-color").length) {
    	//console.log(1);
      $("#option-select-color").on("change", function() {
      	let var_id = $(".variants input[name=id]").val();
        $(".item img[data-variant-id]").css("display", "none");
        $(".item img[data-variant-id=" + var_id + "]").css("display", "block");
      });
    }
    
     $(".product .shopify-section:not(:empty), main:not(:empty)").each(function(i){
             $(this).children().parent().addClass('background');
       		if (!$(this).hasClass("background")) {		
       			$(this).remove();
            }
    });
    
    $('.typeahead__button').click(function(){
      $('.typeahead__query').toggleClass('active');
    });

    $("#app-body").click(function(){
      $(".typeahead__query.active").removeClass("active");
    });
    
    $(function() {
      var url = window.location.href;
      $('.icon-menu li').each(function() {
        if ($('a',this).attr('href') == url) {
          $(this).addClass('is-selected');
        }
        console.log(url);
      });
    });
    
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
    
});
      

}(jQuery);